import {useNavigate} from 'react-router-dom';
import {RootState} from '../../Config/Store';
import {useAppDispatch, useAppSelector} from '../../Config/Hooks';
import {SystemRoutes} from '../../Utils/RouteUtils';
import {setEquipment, setPowerPlant, setSkid} from '../../Modules/Dashboard/DashboardReducer';
import {useEffect, useState} from 'react';
import {DashboardNavigationMenu} from "../Components/Layout/menu/types/DashboardNavigationMenu";

// ao clicar no hiperlink de um equipamento, o Inversor (equipmentType.id === 2) deve abrir
// a tela SIMPLIFICADA do inversor, e não a tela genérica de detalhes. Vale para todos os callers
// deste hook (telas de Alarmes Geral/Usina/Skid, ActiveAlarms, etc.).
const INVERTER_EQUIPMENT_TYPE_ID = 2;

const isInverterEquipment = (equipment: { id: number; equipmentType?: { id: number } } | null | undefined): boolean =>
    equipment?.equipmentType?.id === INVERTER_EQUIPMENT_TYPE_ID;

export const useEquipmentNavigation = (): (equipmentId: number) => { isSuccess: boolean } => {
    const [equipmentId, setEquipmentId] = useState<number | null>(null);
    const [equipmentWithoutSkid, setEquipmentWithoutSkid] = useState<boolean | null>(null);
    const [inverter, setInverter] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { selectedEquipment } = useAppSelector((state: RootState) => state.dashboard);
    const { entities } = useAppSelector((state: RootState) => state.dashboardNavigationMenu);

    useEffect(() => {
        if (equipmentId) {
            if (inverter) {
                navigate(SystemRoutes.DASHBOARD_POWER_PLANT_INVERTER_SIMPLE);
            } else if(equipmentWithoutSkid){
                navigate(SystemRoutes.DASHBOARD_POWER_PLANT_EQUIPMENTS_DETAILS);
            } else {
                navigate(SystemRoutes.DASHBOARD_POWER_PLANT_SKID_EQUIPMENTS_DETAILS);
            }
            setEquipmentId(null)
            setEquipmentWithoutSkid(null);
            setInverter(false);
        }
    }, [selectedEquipment, equipmentId]);

    function navigateToEquipment(equipmentId: number): { isSuccess: boolean } {
        if (!equipmentId) {
           return { isSuccess: false };
        }

        const equipmentInfoById = equipmentInfo(entities, equipmentId);

        if (!equipmentInfoById) {
            return { isSuccess: false };
        }

        const isInverter = isInverterEquipment(equipmentInfoById.equipment);

        // setPowerPlant zera selectedSkid e selectedEquipment no reducer, então precisa vir
        // ANTES do setSkid/setEquipment — senão o breadcrumb e a tela simplificada abrem sem contexto.
        dispatch(setPowerPlant(equipmentInfoById.powerPlant));

        if(equipmentInfoById.skid == null){
            dispatch(setEquipment(equipmentInfoById.equipment));
            setEquipmentId(equipmentId);
            setEquipmentWithoutSkid(true);
            setInverter(isInverter);
            return { isSuccess: true };
        } else if(equipmentInfoById.skid != null) {
            dispatch(setSkid(equipmentInfoById.skid));
            dispatch(setEquipment(equipmentInfoById.equipment));
            setEquipmentId(equipmentId);
            setEquipmentWithoutSkid(false);
            setInverter(isInverter);
            return { isSuccess: true };
        }
        return { isSuccess: false };
    }

    return navigateToEquipment;
}

const equipmentInfo = (entities: DashboardNavigationMenu[], equipmentId: number) => {
    for (const powerStation of entities) {
        for (const skid of powerStation.skidList) {
            for (const equipment of skid.equipmentList) {
                if(equipmentId === equipment.id) {
                    return { powerPlant: powerStation, skid, equipment };
                }
            }
        }
        for (const equipment of powerStation.equipmentList) {
                if(equipmentId === equipment.id) {
                    return { powerPlant: powerStation, skid: null, equipment };
                }
        }
    }

    return null;
}
